// Generated by ReScript, PLEASE EDIT WITH CARE

import * as AsyncData from "./AsyncData.res.js";

function doneOk(ok) {
  return {
    TAG: "Done",
    _0: {
      TAG: "Ok",
      _0: ok
    }
  };
}

function reloadingOk(ok) {
  return {
    TAG: "Reloading",
    _0: {
      TAG: "Ok",
      _0: ok
    }
  };
}

let map = AsyncData.map;

function mapOk(asyncResult, transform) {
  return AsyncData.map(asyncResult, result => {
    if (result.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: transform(result._0)
      };
    } else {
      return result;
    }
  });
}

function mapError(asyncResult, transform) {
  return AsyncData.map(asyncResult, result => {
    if (result.TAG === "Ok") {
      return result;
    } else {
      return {
        TAG: "Error",
        _0: transform(result._0)
      };
    }
  });
}

let notAsked = AsyncData.notAsked;

let loading = AsyncData.loading;

let reloading = AsyncData.reloading;

let done = AsyncData.done;

let isReloading = AsyncData.isReloading;

let isBusy = AsyncData.isBusy;

let isDone = AsyncData.isDone;

let isIdle = AsyncData.isIdle;

let toBusy = AsyncData.toBusy;

export {
  notAsked,
  loading,
  reloading,
  done,
  doneOk,
  reloadingOk,
  isReloading,
  isBusy,
  isDone,
  isIdle,
  toBusy,
  map,
  mapOk,
  mapError,
}
/* No side effect */
